import { useRef } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { WithLoadingSpinner } from "@rentablo/components";
import { ChartWrapper } from "../common";
import { useChartOptions } from "./useChartOptions";
import { ProgressionBarSeries } from "./types";

type Props = {
  chartData?: ProgressionBarSeries[];
  width?: number;
  height?: number;
  isLoading?: boolean;
};

export const ProgressionBarChart = ({
  chartData,
  height,
  isLoading,
}: Props) => {
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

  const chartOptions = useChartOptions(chartData, height);

  return (
    <WithLoadingSpinner isLoading={Boolean(isLoading)}>
      {!isLoading && (
        <ChartWrapper>
          <HighchartsReact
            highcharts={Highcharts}
            ref={chartComponentRef}
            options={chartOptions}
            isLoading={Boolean(isLoading)}
          />
        </ChartWrapper>
      )}
    </WithLoadingSpinner>
  );
};
